module.exports = __webpack_public_path__ + "img/internet_connected_light.13ab4dbd.svg";